module.exports = __webpack_public_path__ + "static/media/sleepiness.e4e15427.svg";